// Deterministic seeded RNG + hashing. Shared. FROZEN CONTRACT.

/** mulberry32 PRNG; returns a function yielding floats in [0,1). */
export function mulberry32(seed: number): () => number {
  let a = seed >>> 0
  return function () {
    a |= 0
    a = (a + 0x6d2b79f5) | 0
    let t = Math.imul(a ^ (a >>> 15), 1 | a)
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }
}

/** Mix arbitrary integers into a single 32-bit hash (for per-chunk/per-tile seeds). */
export function hashInts(...ns: number[]): number {
  let h = 0x811c9dc5
  for (const n of ns) {
    let x = n | 0
    x = Math.imul(x ^ (x >>> 16), 0x45d9f3b)
    x = Math.imul(x ^ (x >>> 16), 0x45d9f3b)
    x ^= x >>> 16
    h = Math.imul(h ^ x, 0x01000193)
  }
  return h >>> 0
}

/** Convenience: a PRNG seeded from several integers. */
export function rngFor(...ns: number[]): () => number {
  return mulberry32(hashInts(...ns))
}

/** Pick a random element. */
export function pick<T>(rand: () => number, arr: readonly T[]): T {
  return arr[Math.floor(rand() * arr.length)]
}

/** Random integer in [min, max] inclusive. */
export function randInt(rand: () => number, min: number, max: number): number {
  return min + Math.floor(rand() * (max - min + 1))
}
